var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66937 55.9272C5.15594 57.2491 2.79734 58.9652 0.686563 61.0758C0.247031 61.5152 0 62.1127 0 62.7344C0 63.3562 0.247031 63.9522 0.686563 64.3916C6.33531 70.0399 13.7527 72.8632 21.1725 72.8632C25.8681 72.8632 30.5641 71.7296 34.8111 69.4666C24.8383 68.3207 15.6059 63.8819 8.40109 56.6769C8.15375 56.4296 7.91016 56.1793 7.66937 55.9272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.33 55.9277C72.0894 56.1798 71.8459 56.4298 71.5988 56.677C64.3933 63.8826 55.1597 68.3216 45.1858 69.467C49.4333 71.731 54.1294 72.8645 58.8274 72.8645C66.2455 72.8645 73.6661 70.0399 79.3134 64.3929C79.753 63.9534 80 63.3559 80 62.7343C80 62.1127 79.753 61.5165 79.3134 61.0771C77.202 58.966 74.8434 57.2498 72.33 55.9277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2454 14.9464C25.137 13.5658 22.8837 12.373 20.5025 11.3913C19.9042 11.1447 19.2625 11.1639 18.7087 11.3944C18.155 11.6249 17.689 12.0668 17.4425 12.6649C16.465 15.0357 15.7257 17.4641 15.2195 19.9218C18.1775 20.8077 21.0312 21.9986 23.741 23.4807C24.6082 20.5196 25.7823 17.6622 27.2454 14.9464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7807 19.9218C64.2745 17.4641 63.5353 15.0357 62.5578 12.6649C62.311 12.0668 61.8451 11.6249 61.2915 11.3944C60.7378 11.1639 60.0959 11.1447 59.4978 11.3913C57.1164 12.3729 54.8631 13.5658 52.7546 14.9464C54.2178 17.6621 55.392 20.5196 56.2593 23.4807C58.969 21.9986 61.8228 20.8077 64.7807 19.9218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9222 64.2653C25.4552 56.3253 21.9384 46.4868 21.9384 36.107C21.9384 33.4411 22.1719 30.8114 22.6261 28.2398C16.5444 24.6498 9.59172 22.7332 2.34375 22.7334C1.69672 22.7334 1.11063 22.9957 0.686563 23.42C0.262344 23.844 3.96039e-08 24.4301 3.96039e-08 25.0771C-0.00046871 35.762 4.16016 45.8073 11.7156 53.3628C17.3295 58.9765 24.3183 62.7142 31.9222 64.2653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0615 36.107C58.0615 46.4868 54.5448 56.3254 48.0779 64.2653C55.6818 62.7142 62.6707 58.9765 68.2844 53.3628C75.8399 45.8073 80.0005 35.762 80.0001 25.0771C80.0001 24.4301 79.7377 23.844 79.3135 23.42C78.8894 22.9959 78.3034 22.7336 77.6563 22.7334C70.4083 22.7331 63.4557 24.6498 57.3738 28.2398C57.828 30.8114 58.0615 33.4411 58.0615 36.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6574 7.82166C41.1999 7.36416 40.5999 7.13525 40 7.13525C39.4002 7.13525 38.8004 7.36416 38.3427 7.82166C30.7871 15.3767 26.626 25.4218 26.626 36.1068C26.626 46.7918 30.7871 56.837 38.3427 64.392C38.8002 64.8495 39.4002 65.0784 40 65.0784C40.5999 65.0784 41.1997 64.8495 41.6574 64.392C49.213 56.837 53.3741 46.7918 53.3741 36.1068C53.3741 25.4218 49.2129 15.3767 41.6574 7.82166Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotus);
export default __webpack_public_path__ + "static/media/lotus.790cb8d9a29616fff35009b79505ab64.svg";
export { ForwardRef as ReactComponent };